import { INCREMENT_PAGE_COUNT_ACTION } from './PageCountConstants';

export default (state = 0, action) => {
    switch (action.type) {
        case INCREMENT_PAGE_COUNT_ACTION:
            return state + 1;
        default:
            return state;
    }
};
